import { useMemo } from "react";

import { addJWTInConfig } from "../../components/apiHooks/helpers";
import useApiRequestPost from "../../components/apiHooks/useApiRequestPost";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { IGetKitchenOrdersResponse } from "./types";

const POLL_INTERVAL_MS = 15000;

const useGetKitchenOrders = () => {
	const { state: user } = useConfigContext((state) => state.user);
	const { state: qrSession } = useConfigContext((state) => state.qrSession);

	const payload = useMemo(() => {
		const host = process.env.CLOUD_RUN_GATEWAY_HOST ?? "";
		const endpoint = process.env.API_KITCHEN_ORDER_GET ?? "";
		const url = qrSession?.qrs_id && qrSession?.bb_uuid ? `${host}${endpoint}` : null;

		return {
			url,
			triggerOnMount: true,
			axiosConfig: addJWTInConfig(undefined, user?.session_id?.toString() ?? ""),
			body: {
				qrs_id: qrSession?.qrs_id ?? "",
				bb_uuid: qrSession?.bb_uuid ?? "",
			},
			swrConfig: {
				revalidateOnFocus: false,
				refreshInterval: POLL_INTERVAL_MS,
			},
		};
	}, [user?.session_id, qrSession?.qrs_id, qrSession?.bb_uuid]);

	const { data, isLoading, error } = useApiRequestPost<IGetKitchenOrdersResponse>(payload);

	return { orders: data?.data ?? [], isLoading, error };
};

export default useGetKitchenOrders;
